export const PortalEnvironments = {
    LOCALHOST: "LOCALHOST",
    DEV: "DEV",
    QA: "QA",
    PROD: "PROD"
};

export const PortalEnvironmentUrls = {
    [PortalEnvironments.LOCALHOST]: ["http://localhost:3000"],
    [PortalEnvironments.DEV]: ["https://api-portal-fi-api-dev.ingress.nap01.ocp.six-group.net"],
    [PortalEnvironments.QA]: ["https://bfi-mvp-portal-qa.np.six-group.com", "https://api-portal-fi-api-qa.ingress.osl01.ocp.six-group.net"],
    [PortalEnvironments.PROD]: ["https://web.apiportal.six-group.com"]
};

export const BackEndEnvironmentUrls = {
    QA: "https://api-qa.np.six-group.net",
    PREPROD: "https://api-preprod.np.six-group.com",
    PROD: "https://api.six-group.com"
}

export const BackEndEnvironmentWebSockets = {
    QA: "wss://api-qa.np.six-group.net",
    PREPROD: "wss://api-preprod.np.six-group.com",
    PROD: "wss://api.six-group.com"
}

export const WebSocketSchemaUrls = {
    V1: "https://api.six-group.com/web/v1/graphql/sdl",
    V2: "https://api.six-group.com/web/v2/graphql/sdl"
}

export const BackEndEnvironments = {
    QA: "QA",
    PREPROD: "PREPROD",
    PROD: "PROD"
}

export const PageNames = {
    Home: "home",
    Catalog: "catalog",
    Showcase: "showcase",
    GraphQLExplorer: "graphql-explorer",
    Documentation: "documentation",
    ReleaseNotes: "release-notes",
    DataDictionary: "data-dictionary",
    BulkAPIDocumentation: "bulk-api-documentation",
    BulkAPIDataDictionary: "bulk-api-data-dictionary",
    MarketsList: "markets-list",
};

export const PageDisplayNames = {
    Home: "Home",
    Catalog: "Catalog",
    Showcase: "Showcase",
    GraphQLExplorer: "GraphQL Explorer",
    Documentation: "Documentation",
    ReleaseNotes: "Release Notes",
    DataDictionary: "Data Dictionary",
    BulkAPIDocumentation: "Bulk API Documentation",
    BulkAPIDataDictionary: "Bulk API Data Dictionary",
    MarketsList: "Markets List"
};

export const PAGE_TITLE_BASE = "API Portal - ";

export const TabNames = {
    Overview: "overview",
    Content: "content",
    Swagger: "swagger",
    SwaggerRedirect: "swagger-redirect",
    VersionHistory: "version-history",
    APIDefinition: "api-definition",
    QueryBuilder: "query-builder",
    Criteria: "criteria",
    WebsocketExplorer: "websocket-explorer"
};

export const TabDisplayNames = {
    Overview: "Overview",
    Content: "Content",
    Swagger: "Swagger",
    VersionHistory: "Version History",
    APIDefinition: "API Definition",
    QueryBuilder: "Query Builder",
    Criteria: "Criteria",
    WebsocketExplorer: "Websocket Explorer"
};

export const GroupNames = {
    ReferenceData: "Reference Data",
    MarketData: "Pricing",
    Search: "Search",
    EstimatesAndFundamentals: "Estimates And Fundamentals",
    CorporateActions: "Corporate Actions",
    News: "News",
    Tax: "Tax",
    InvestorProtection: "Investor Protection"
};

export const ApiTypes = {
    WebApi: "Web API",
    BulkApi: "Bulk API"
};

export const InstrumentSchemes = {
    TICKER_BC: "TICKER_BC",
    ISIN: "ISIN",
    VALOR_BC: "VALOR_BC",
    SEDOL_BC: "SEDOL_BC",
    CUSIP_BC: "CUSIP_BC",
    BC: "BC",
};

export const SecurityTypes = {
    COMMODITY: "Commodity",
    DEBT: "Debt",
    ETD: "ETD",
    ETD_CONTRACT_SPECIFICATION: "ETD Contract Specification",
    EQUITY: "Equity",
    INVESTMENT_TRUST_UNIT_SHARE: "Investment Trust Unit Share",
    LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT: "Leveraged Product Subscription Right",
    STRUCTURED_PRODUCT: "Structured Product"
};

export const SecurityTypesList = [
    'Commodity',
    'Debt',
    'ETD',
    'ETD Contract Specification',
    'Equity',
    'Investment Trust Unit Share',
    'Leveraged Product Subscription Right',
    'Structured Product'
];

export const APINames = {
    instrumentBase: "instrumentBase",
    entityBase: "entityBase",
    listingBase: "listingBase",
    marketBase: "marketBase",
    instrumentSymbology: "instrumentSymbology",
    listingSymbology: "listingSymbology",
    instrumentMarkets: "instrumentMarkets",
    indexComposition: "indexComposition",
    instrumentClassification: "instrumentClassification",
    entityClassification: "entityClassification",
    instrumentDetail: "instrumentDetail",
    marketHolidays: "marketHolidays",
    issueCondition: "issueCondition",
    mifidIISuitability: "mifidIISuitability",
    mifidIICostAndCharges: "mifidIICostAndCharges",
    streamingMarketData: "streamingMarketData",
    streamingMarketDataV3: "streamingMarketDataV3",
    intradaySnapshot: "intradaySnapshot",
    intradayHistory: "intradayHistory",
    streamingIntradayTradesWithHistory: "streamingIntradayTradesWithHistory",
    endOfDayHistory: "endOfDayHistory",
    endOfDaySnapshot: "endOfDaySnapshot",
    freeTextSearch: "freeTextSearch",
    criteriaSearch: "criteriaSearch",
    estimates: "estimates",
    fundamentals: "fundamentals",
    swissStampDuty: "swissStampDuty",
    corporateActions: "corporateActions",
    fixedIncomeReferenceDataExtended: "fixedIncomeReferenceDataExtended",
    digitalAssetsRegulatoryAndTaxServices: "digitalAssetsRegulatoryAndTaxServices"
};

export const APIDisplayNames = {
    InstrumentBase: "Instrument Base",
    EntityBase: "Entity Base",
    ListingBase: "Listing Base",
    MarketBase: "Market Base",
    InstrumentSymbology: "Instrument Symbology",
    ListingSymbology: "Listing Symbology",
    InstrumentMarkets: "Instrument Markets",
    IndexComposition: "Index Composition",
    InstrumentClassification: "Instrument Classification",
    EntityClassification: "Entity Classification",
    InstrumentDetail: "Instrument Detail",
    MarketHolidays: "Market Holidays",
    IssueCondition: "Issue Condition",
    MifidIISuitability: "MiFID II Suitability",
    MifidIICostAndCharges: "MiFID II Cost And Charges",
    StreamingMarketData: "Streaming Market Data",
    StreamingMarketDataV3: "Streaming Market Data V3",
    IntradaySnapshot: "Intraday Snapshot",
    IntradayHistory: "Intraday History",
    StreamingIntradayTradesWithHistory: "Streaming Intraday Trades with History",
    EndOfDayHistory: "End of Day History",
    EndOfDaySnapshot: "End of Day Snapshot",
    FreeTextSearch: "Free Text Search",
    CriteriaSearch: "Criteria Search",
    Estimates: "Estimates",
    Fundamentals: "Fundamentals",
    SwissStampDuty: "Swiss Stamp Duty",
    CorporateActions: "Corporate Actions",
    FixedIncomeReferenceDataExtended: "Fixed Income Reference Data - Extended",
    DigitalAssetsRegulatoryAndTaxServices: "Digital Assets Regulatory and Tax Services (DARTS)"
};

export const WebAPINames = {
    instrumentBase: "instrumentBase",
    entityBase: "entityBase",
    listingBase: "listingBase",
    marketBase: "marketBase",
    instrumentSymbology: "instrumentSymbology",
    listingSymbology: "listingSymbology",
    instrumentMarkets: "instrumentMarkets",
    indexComposition: "indexComposition",
    instrumentClassification: "instrumentClassification",
    entityClassification: "entityClassification",
    instrumentDetail: "instrumentDetail",
    streamingMarketData: "streamingMarketData",
    intradaySnapshot: "intradaySnapshot",
    intradayHistory: "intradayHistory",
    marketHolidays: "marketHolidays",
    issueCondition: "issueCondition",
    mifidIISuitability: "mifidIISuitability",
    mifidIICostAndCharges: "mifidIICostAndCharges",
    streamingIntradayTradesWithHistory: "streamingIntradayTradesWithHistory",
    endOfDayHistory: "endOfDayHistory",
    endOfDaySnapshot: "endOfDaySnapshot",
    freeTextSearch: "freeTextSearch",
    criteriaSearch: "criteriaSearch",
    estimates: "estimates",
    fundamentals: "fundamentals",
    swissStampDuty: "swissStampDuty"
};

export const BulkAPINames = {
    corporateActions: "corporateActions",
    fixedIncomeReferenceDataExtended: "fixedIncomeReferenceDataExtended",
    digitalAssetsRegulatoryAndTaxServices: "digitalAssetsRegulatoryAndTaxServices"
};

export const ChangeTypes = {
    Added: "Added",
    Changed: "Changed",
    Deprecated: "Deprecated",
    Removed: "Removed",
    Fixed: "Fixed",
    Security: "Security",
};

export const APIMajorVersions = {
    v1: "v1",
    v2: "v2"
};

//this version should be merged with APIMajorVersions when introducing v3 for rest api
export const StreamingMarketDataV3MajorVersion = "v3";

/* conflationPeriod is a free-form ISO 8601 duration in the AsyncAPI spec - the minimum of
   100ms and the maximum of 1 minute live only in its description - so the periods offered in
   the Websocket Explorer are a portal-side selection rather than a spec enum. The labels spell
   the duration out because "PT0.1S" does not read as 100 milliseconds at a glance.
   Note "PT1M" rather than "PT60S": the spec asks for periods shorter than a minute in seconds
   and says nothing about which form a full minute takes. */
export const ConflationPeriods = [
    { value: "PT0.1S", label: "PT0.1S — 100 ms (minimum)" },
    { value: "PT0.5S", label: "PT0.5S — 500 ms" },
    { value: "PT1S", label: "PT1S — 1 second" },
    { value: "PT2S", label: "PT2S — 2 seconds" },
    { value: "PT5S", label: "PT5S — 5 seconds" },
    { value: "PT10S", label: "PT10S — 10 seconds" },
    { value: "PT30S", label: "PT30S — 30 seconds" },
    { value: "PT1M", label: "PT1M — 1 minute (maximum)" }
];

export const APIV1MinorVersions = {
    "2023-01-01": "2023-01-01",
    "2024-01-01": "2024-01-01",
    "2024-03-01": "2024-03-01",
    "2024-06-01": "2024-06-01",
    "2024-08-01": "2024-08-01",
    "2024-10-01": "2024-10-01",
    "2025-05-01": "2025-05-01",
    "2025-11-02": "2025-11-02",
    "2026-01-02": "2026-01-02"
};

export const APIV2MinorVersions = {
    "2025-06-01": "2025-06-01",
    "2025-10-01": "2025-10-01",
    "2025-11-01": "2025-11-01",
    "2026-01-01": "2026-01-01",
    "2026-03-01": "2026-03-01",
    "2026-05-01": "2026-05-01",
    "2026-05-16": "2026-05-16",
    "2026-06-01": "2026-06-01",
    "2026-07-01": "2026-07-01",
    "2026-09-01": "2026-09-01"
};

export const ReleaseDates = {
    "2023-04-25": "2023-04-25",
    "2024-01-17": "2024-01-17",
    "2024-03-07": "2024-03-07",
    "2024-06-13": "2024-06-13",
    "2024-08-21": "2024-08-21",
    "2024-08-30": "2024-08-30",
    "2024-10-31": "2024-10-31",
    "2025-05-31": "2025-05-31",
    "2025-09-02": "2025-09-02",
    "2025-10-20": "2025-10-20",
    "2025-12-06": "2025-12-06",
    "2026-02-14": "2026-02-14",
    "2026-03-28": "2026-03-28",
    "2026-05-02": "2026-05-02",
    "2026-05-23": "2026-05-23",
    "2026-07-04": "2026-07-04",
    "2026-07-25": "2026-07-25",
    "2026-09-26": "2026-09-26"
};

export const SwaggerUIBaseParams = {
    title: "SIX Web API",
    apiVersionDescription: "The API version is represented as a date in ISO 8601 format. If not explicitly specified, the system will default to the latest version available. Valid versions for",
    preferredLanguage: "Language in ISO 639 alpha-2 code for string fields where content in different languages is available.",
    extensions: "Select Extensions to know more about the GraphQL query, Data Status and Dataset IDs. EXPLAIN = include the equivalent GraphQL query in the REST API response."
}

export const LATEST_V1_MINOR_VERSION = Object.keys(APIV1MinorVersions).findLast((element) => element);
export const LATEST_V2_MINOR_VERSION = Object.keys(APIV2MinorVersions).findLast((element) => element);
export const LATEST_MAJOR_VERSION = Object.keys(APIMajorVersions).findLast((element) => element);

export const LATEST_RELEASE_DATE = Object.keys(ReleaseDates).findLast((element) => element);
